// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"42f69837","240":"addadd72","280":"712c86f9","287":"81534122","301":"4ed9f087","308":"19e0c8c2","421":"4107c84e","471":"465231d1","559":"c244e76c","677":"fb528d61","924":"afb6f59b"}[chunkId] + ".chunk.js";
};